import { SERVER_URI } from '../Constant/server';
import { apiGet, apiPost, apiPut } from '../utils/axios';

const BIND_PRODUCT = SERVER_URI + '/get-products';
const ADD_PRODUCT = SERVER_URI + '/products';
const ADD_COMBO_PRODUCT = SERVER_URI + '/products';
const UPDATE_STATUS = SERVER_URI + '/change-product-status/'
const UPDATE_PRODUCT = SERVER_URI + '/products/'
const GET_TIME = SERVER_URI + '/get-time/'
const GET_SUB_PRODUCT = SERVER_URI + '/get-sub-products/'
const GET_LOCATIONBASE_PRODUCT= SERVER_URI + '/get-location-products'


export default {
    addProduct: async function (paylaod) {
        // console.log("discount payload", paylaod)
        return apiPost(ADD_PRODUCT, paylaod)
    },

    Get_Product: async function (paylaod) {
        return apiPost(BIND_PRODUCT, paylaod)
    },
    addComboProduct: async function (paylaod) {
        // console.log("discount payload", paylaod)
        return apiPost(ADD_COMBO_PRODUCT, paylaod)
    },
    changeProductStatusData: async function (id) {
        return apiGet(UPDATE_STATUS + id)
    },
    updateProduct: async function (id, payload) {
        // console.log("update...",id,payload)
        return apiPut(UPDATE_PRODUCT + id, payload)
    },
    getTime: async function () {
        return apiGet(GET_TIME )
    },
    getSubProduct: async function (id) {
        return apiGet(GET_SUB_PRODUCT + id)
    },
    getLocationBaseProduct: async function (payload) {
        return apiPost(GET_LOCATIONBASE_PRODUCT , payload)
    },

};